import { StateType } from '../../index';

export const achievementsDataSelector = (state: StateType) => state.getIn(['dashboard', 'achievements', 'data']);
export const achievementsIsFetchingSelector = (state: StateType) => state.getIn(['dashboard', 'achievements', 'isFetching']);
